import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import Filters from "@/filters";
import VueMeta from "vue-meta";
import Vue2Filters from "vue2-filters";
import VueMask from "v-mask";
import VueOnlineProp from "vue-online-prop";
import SnackBar from "@/plugins/snackbar";
import VueGeolocationApi from "vue-geolocation-api";
import { i18n } from "@/plugins/i18n";
import { init } from "@services";
import { Device } from "@capacitor/device";
import { Network } from "@capacitor/network";
import "@ranes-inc/shared-lib/dist/shared-lib.css";
import process from "../.eslintrc";
Vue.use(Vue2Filters);
Vue.use(Filters);
Vue.use(VueMeta, { refreshOnceOnNavigation: true });
Vue.use(VueMask);
Vue.use(SnackBar, { store });
Vue.use(VueGeolocationApi);
Vue.use(VueOnlineProp);

Device.getInfo().then((a) => {
  Vue.prototype.$deviceInfo = a;
  Vue.prototype.$platform = a.platform;
  Vue.prototype.$androidSDKVersion = a.androidSdkVersion;
  Vue.prototype.$networkInitialized = false;

  if (a.platform !== "web") {
    Network.addListener("networkStatusChange", (status) => {
      Vue.prototype.$network = status.connected;
      Vue.prototype.$online = status.connected;
    });

    Network.getNetworkStatus().then((n) => {
      Vue.prototype.$network = n.connected;
      Vue.prototype.$online = n.connected;
      Vue.prototype.$networkInitialized = true;
    });
  } else {
    Vue.prototype.$networkInitialized = true;
  }
});

Device.getId().then((a) => {
  Vue.prototype.$deviceId = a.uuid;
});

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
  data: {
    nav: ["dashboard", "timeclock", "forms", "messages", "documents"],
  },
  async beforeCreate() {
    store.commit("api/apiURL", window.appConfig?.VUE_APP_SAFETY_API_URL);

    // baked by build system
    const version = process.env.VUE_APP_VERSION;
    store.commit("settings/version", version);

    store.commit("api/apiKey", "obsolete");

    init();
  },
}).$mount("#app");
